import React, { useState } from 'react';
import { toast } from 'react-toastify';
import CustomButton from '../../custom/custom-button/CustomButton';
import CustomInput from '../../custom/custom-input/CustomInput';
import styles from "../common.module.scss";
import { useNavigate } from 'react-router-dom';
import { validateEmail } from '../../../utils/checkEmail';
import { User } from '../../../services';
import { t } from "i18next";

const EnterEmailComponent = ({ data, updateStep, setData }) => {
    const navigate = useNavigate();

    const [userEmail, setUserEmail] = useState(data?.userEmail || '');
    const [isLoading, setIsLoading] = useState(false);
    const [errorText, setErrorText] = useState('');

    const nextStep = function () {
        if (!validateEmail(userEmail)) {
            setErrorText("Неверный формат электронной почты");
            return;
        }
        setIsLoading(true);

        User.forgotPassword(userEmail)
            .then(response => {
                if (response.data.isSucccess === true) {
                    updateStep(2);
                    setData({ ...data, userEmail: userEmail });
                    toast.info("Код для восстановление пароля отправлен на вашу почту");
                    setIsLoading(false);
                } if (response.status === 204) {
                    setErrorText("Такой e-mail не зарегистрирован");
                    setIsLoading(false);
                } else {
                    setErrorText("Ошибка при отправки письма");
                    setIsLoading(false);
                }
            })
            .catch(error => {
                setErrorText(error.message);
                setIsLoading(false);
            });
    };

    return (
        <>
            <div className={styles.card_form}>
                <CustomInput value={userEmail} isDeleteText={true} labelText="E-mail" inputType="text" placeholder={t('registrationForm.email.placeholder')} onChangeValue={setUserEmail} errorText={errorText} />
            </div>

            <div className={styles.btns}>
                <CustomButton isFall isDisabled={!validateEmail(userEmail)} text={t('registrationForm.buttons.continue')} onClick={nextStep} isLoading={isLoading} />
                <CustomButton isFall text={t('restorePasswordPage.rememberedPassword')} isUnderline={true} onClick={() => navigate('/login')} />
            </div>
        </>
    );
}

export default EnterEmailComponent;
